<app-content>
  <app-breadcrumbs>
    <li>
      Płatności online
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Płatności online
    </h2>
    @if (!loading()) {
      <form novalidate autocomplete='off' [formGroup]='form'>
        <div class='row'>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"payer" as controlName'>
              <label [for]='controlName'>
                Płatnik *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option [value]='null'>Wybierz</option>
                <option [value]='item' *ngFor='let item of payers()'>
                  {{ item?.name || (item?.firstName + ' ' + item?.lastName) }}
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <fieldset>
          <legend>Pozycje za które chcesz zapłacić</legend>
          <br>
          <div class='row'>
            <div class='col-md-6'>
              <app-alert [closable]='false'>
                Wymagane zaznaczenie <strong>min. 1 pozycji</strong>.
              </app-alert>
            </div>
          </div>
          <br>
          <div class='row' formArrayName='attachmentPositions'>
            @for (position of attachmentPositions(); track position.id) {
              <div class='col-12' [formGroupName]='$index + ""'>
                <div class='form-group' *ngIf='"checked" as controlName'>
                  <div class='custom-checkbox custom-inline'>
                    <input
                      [attr.aria-describedby]='"quantity" + $index'
                      [formControlName]='controlName'
                      type='checkbox'
                      [id]='"position" + $index'
                      [name]='"position" + $index'>
                    <label [for]='"position" + $index'>
                      {{ position.fee?.name }} <strong>(1 x {{ position.fee?.price | currency }})</strong>
                    </label>
                  </div>
                  <div class='d-inline-flex align-items-center' style='padding-bottom: 1.25rem; padding-top: 1.5rem;'>
                    <button
                      (click)="form.increaseQuantity($index)"
                      type='button'
                      title='Więcej'
                      class='btn btn-secondary icon-btn'>
                      <i aria-hidden='true' class='fa fa-plus'></i>
                    </button>&nbsp;
                    <button
                      (click)="form.decreaseQuantity($index)"
                      type='button'
                      title='Mniej'
                      class='btn btn-secondary icon-btn'>
                      <i aria-hidden='true' class='fa fa-minus'></i>
                    </button>&nbsp;
                    <p [id]='"quantity" + $index'>
                      Ilość:
                      <strong>
                        {{ form.getQuantity($index).value }}
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            }
          </div>
        </fieldset>
        <div class='d-flex justify-content-end'>
          <app-label
            label='Wysokośc opłaty:'>{{ form.totalAmount || '0.00' | currency }}
          </app-label>
        </div>
        <hr>
        <br>
        <div class='form-actions'>
          <a [routerLink]='goBackPath'
             class='btn btn-secondary'>
            Anuluj
          </a>
          <button (click)="onSubmit()" type='button' class='btn btn-primary'>
            Dokonaj płatności
          </button>
        </div>
      </form>
    } @else {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    }
  </section>
</app-content>
